import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CookiesService {
  public getCookie(name: string): string | null {
    const matches = new RegExp(`(?:^|; )${name.replace(/([.*+?^${}()|[\]\\])/g, '\\$&')}=([^;]*)`).exec(
      document.cookie,
    );
    return matches ? decodeURIComponent(matches[1]) : null;
  }

  public setCookie(name: string, value: string, days: number): void {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);
    document.cookie = `${name}=${encodeURIComponent(value)}; path=/; expires=${expires.toUTCString()}`;
  }
}
